export default {
  'step1': 'メール検証',
  'step2': '事前確認',
  'step3': '法人情報',
  'step4': 'E-KYC',
  'step5': 'ストア情報',
  'step6': '決済関連情報',
  'step7': '書類アップロード',
  'new': '新規申請'
}
